import { createPdfCacheKey } from './reportTemplateUtils.js'

// A viewer owns this small cache; cancelled and superseded responses never enter it.
export function createReportPdfRequest(downloadPdf, maxEntries = 3) {
  const cache = new Map()
  let controller = null
  let requestVersion = 0
  let cachedReportId = null

  async function load(reportId, templateId, templateVersion) {
    const version = ++requestVersion
    controller?.abort()
    controller = new AbortController()
    if (cachedReportId !== reportId) {
      cache.clear()
      cachedReportId = reportId
    }
    const key = createPdfCacheKey(reportId, templateId, templateVersion)
    const cached = cache.get(key)
    try {
      const result = cached || await downloadPdf(reportId, templateId, { signal: controller.signal })
      if (version !== requestVersion) return null
      cache.delete(key)
      cache.set(key, result)
      while (cache.size > maxEntries) cache.delete(cache.keys().next().value)
      return result
    } catch (cause) {
      if (version !== requestVersion || cause.name === 'AbortError') return null
      throw cause
    }
  }

  function dispose() {
    requestVersion += 1
    controller?.abort()
    cache.clear()
  }

  return { load, dispose }
}
